import * as actionTypes from 'constants/actionTypes';
import { addTimingMarkInstructionsToAction } from 'utils/timing';

export const checkLoginStatus = token => {
  return {
    type: actionTypes.CHECK_LOGIN_STATUS,
    payload: {
      token,
    },
  };
};

export const syncAfterLogin = user => {
  return {
    type: actionTypes.SYNC_AFTER_LOGIN,
    payload: {
      user,
    },
  };
};

export const initAccountSync = accountId => {
  return {
    type: actionTypes.INIT_ACCOUNT_SYNC,
    payload: { accountId },
  };
};

export const syncAccountWithFirebase = accountId => {
  return addTimingMarkInstructionsToAction({
    type: actionTypes.SYNC_ACCOUNT_WITH_FIREBASE,
    payload: {
      accountId,
    },
  });
};
export const prefetchAccountData = accountId => ({
  type: actionTypes.PREFETCH_ACCOUNT_DATA,
  payload: {
    accountId,
  },
});

export const setFirebaseErrorStatus = error => {
  return {
    type: actionTypes.SET_FIREBASE_ERROR_STATUS,
    payload: {
      error,
    },
  };
};

export const setFirebaseAuthErrorStatus = message => {
  return {
    type: actionTypes.SET_FIREBASE_AUTH_ERROR_STATUS,
    payload: message,
  };
};

export const setFirebaseLastSuccessfulWrite = lastSuccessfulWrite => {
  return {
    type: actionTypes.SET_FIREBASE_LAST_SUCCESSFUL_WRITE,
    payload: {
      lastSuccessfulWrite,
    },
  };
};

export const addPendingWrite = (path, hash) => {
  return {
    type: actionTypes.ADD_PENDING_WRITE,
    payload: {
      path,
      hash,
    },
  };
};

export const removePendingWrite = (path, hash) => {
  return {
    type: actionTypes.REMOVE_PENDING_WRITE,
    payload: {
      path,
      hash,
    },
  };
};

export const updateFirebaseMetadata = updates => {
  return {
    type: actionTypes.UPDATE_FIREBASE_METADATA,
    payload: updates,
  };
};
